import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "New lead", { props: { triggerType: "Form Submitted", event: "Lead magnet opt-in" } }],
  ["e1", "auto-email", "Here's your guide", { props: { subject: "Your download + what's next" } }],
  ["w1", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["e2", "auto-email", "Quick win from the guide", { props: { subject: "Try this one thing today" } }],
  ["w2", "auto-wait", "Wait 3 days", { props: { duration: "3", unit: "days" } }],
  ["e3", "auto-email", "Client story", { props: { subject: "How Dana got results in 2 weeks" } }],
  ["c1", "auto-condition", "Clicked anything?", { props: { condition: "Opened or clicked any email" } }],
  ["tg", "auto-tag-add", "Tag: hot-lead", { props: { tag: "hot-lead" } }],
]);

const def: TemplateDef = {
  slug: "lead-magnet-nurture",
  name: "Lead Magnet + Nurture",
  category: "Lead gen",
  tagline:
    "Deliver the freebie, warm the list, and tag your hot leads for a call.",
  description:
    "A free lead-magnet funnel template: opt-in page, instant delivery email, a value-first nurture sequence, and engagement-based hot-lead tagging that routes to a booking page. Clone it into FrazzleCRM and it runs for real.",
  whatsInside: [
    "Opt-in and delivery pages wired to an instant-delivery email",
    "A value-first nurture: quick win, then a client story",
    "Engagement branch that tags hot leads automatically",
    "Booking page as the natural next step for tagged leads",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-seo", "SEO / Organic", 40, 60, { props: { keywords: "how to ___" } }),
      node("src2", "traffic-tiktok", "TikTok", 40, 220),
      node("op", "page-optin", "Free guide opt-in", 360, 140, { props: { magnet: "The ___ Checklist" } }),
      node("ty", "page-thankyou", "Check your inbox", 680, 140),
      flow("f1", "Nurture Sequence", 1000, 40, 420, 850),
      ...seq.nodes,
      node("bk", "page-booking", "Book a call", 1520, 340, { props: { duration: "30 min" } }),
      node("n1", "util-note", "Why it works", 680, 340, {
        notes:
          "Value first, pitch later: two giving emails before any ask. The hot-lead tag means sales only talks to people who leaned in.",
      }),
    ],
    [
      edge("src1", "op"),
      edge("src2", "op"),
      edge("op", "ty"),
      edge("ty", "f1"),
      ...seq.edges,
      edge("f1", "bk"),
    ]
  ),
};

export default def;
